import React, { useState } from "react";
import { DM_SCRIPTS } from "../../../constants/activationConsoleData";
import { copyActivationText } from "./activationClipboard";

export default function ActivationScriptsTab() {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (message, id) => {
    copyActivationText(message, () => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    });
  };

  return (
    <>
      <div className="ac-inline-note" style={{ marginBottom: 24 }}>
        <strong>You are not pitching.</strong> You are anchoring in accuracy, then allowing distribution. No
        ask in message 1. The unlock is getting 2 organizers to say the sentence before a run.
      </div>
      <div>
        {DM_SCRIPTS.map((s, idx) => (
          <div key={`${s.step}-${idx}`} className="ac-script-card">
            <div className="ac-sc-step">{s.step}</div>
            <div className="ac-sc-title">{s.title}</div>
            <div className="ac-sc-context">{s.context}</div>
            <div className="ac-sc-message">{s.message}</div>
            <div className="ac-sc-footer">
              <div className="ac-sc-note">{s.note}</div>
              <button
                type="button"
                className={`ac-copy-btn ${copiedId === idx ? "copied" : ""}`}
                onClick={() => handleCopy(s.message, idx)}
              >
                {copiedId === idx ? "Copied ✓" : "Copy"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
